import { render, staticRenderFns } from "./GSbyDraw.vue?vue&type=template&id=00023e62&scoped=true&"
import script from "./GSbyDraw.vue?vue&type=script&lang=js&"
export * from "./GSbyDraw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00023e62",
  null
  
)

export default component.exports